/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import mapper from './homepage.analytics';
import {
  HomePageParams,
  HomePageEvents,
  HOME_PAGE_SCREEN_NAME,
} from './homepage.meta';

// UHF Header Actions
export const trackProfileClick = () => mapper[HomePageEvents.Profile_Click]();
export const trackWalletClick = () => mapper[HomePageEvents.Wallet_Click]();
export const trackSearchClick = () => mapper[HomePageEvents.Search_Click]();

// Product Tiles
export const trackProductTilesViewed = (params: HomePageParams) =>
  mapper[HomePageEvents.Product_Tiles_Viewed](params);

export const trackProductTileClick = (params: HomePageParams) =>
  mapper[HomePageEvents.Product_Tile_Click](params);

export const trackSearchTabClick = (params: HomePageParams) =>
  mapper[HomePageEvents.Search_Tab_Click](params);

// Notification Banner
export const trackNotificationBannerViewed = (params: HomePageParams) =>
  mapper[HomePageEvents.Notification_Banner_Viewed](params);

export const trackNotificationBannerClicked = (params: HomePageParams) =>
  mapper[HomePageEvents.Notification_Banner_Clicked](params);

export const trackHeroBannerViewed = (params: HomePageParams) =>
  mapper[HomePageEvents.Hero_Banner_Viewed](params);

export const trackHeroBannerClicked = (params: HomePageParams) =>
  mapper[HomePageEvents.Hero_Banner_Clicked](params);

export const trackArticleCarouselViewed = (params: HomePageParams) =>
  mapper[HomePageEvents.Article_Carousel_Viewed](params);

export const trackArticleCarouselClicked = (params: HomePageParams) =>
  mapper[HomePageEvents.Article_Carousel_Clicked](params);

export const trackRecommendationShowMoreClicked = (params: HomePageParams) =>
  mapper[HomePageEvents.Recommendation_Show_More_Clicked](params);

// Screen View
export const homepageScreenViewEvent = () => ({
  screenName: HOME_PAGE_SCREEN_NAME.home,
  screen_name: HOME_PAGE_SCREEN_NAME.home,
});

// API Error
export const apiErrorEvent = (params: {
  error: unknown;
  functionality: string;
  label: string;
  category: string;
}) => {
  const err = params.error as any;
  const code = String(err?.response?.status ?? err?.code ?? 'UNKNOWN');
  const description = err?.message ?? 'Unknown error';
  return {
    screenName: HOME_PAGE_SCREEN_NAME.home,
    description,
    functionality: params.functionality,
    label: params.label,
    code,
    category: params.category,
  };
};
